import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Button, ToggleSwitch } from "../../../../components";
import { useAppDispatch } from "../../../../redux/store";

import styles from "./AcceptTermsForm.module.scss";

import { Link, useNavigate } from "react-router-dom";

import { AcceptTermsFormPropsType } from "./types";
import { setTotalPriceToStorage, getTokenFromStorage } from "../../../../utils";
import { openAuthModal } from "../../../../utils/authModal/openAuthModal";

export const AcceptTermsForm: React.FC<AcceptTermsFormPropsType> = ({ totalPrice }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { auth } = useSelector((state: any) => state.authAndReg);

  const [acceptTerms, setAcceptTerms] = useState(false);
  const [acceptOffer, setAcceptOffer] = useState(false);
  // const [acceptGrunt, setAcceptGrunt] = useState(false);

  const isAllAccepted = acceptTerms && acceptOffer;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!isAllAccepted) {
      return;
    }

    const token = getTokenFromStorage();
    const isAuthenticated = auth || token;

    if (!isAuthenticated) {
      openAuthModal(dispatch);
      return;
    }

    const onlyNumbersTotalPrice = totalPrice.replace(/\D/g, "");
    setTotalPriceToStorage(onlyNumbersTotalPrice);
    navigate("/payment");
  };

  return (
    <form className={styles.acceptForm} onSubmit={handleSubmit}>
      <div className={styles.acceptForm_section}>
        <div className={styles.toggleSection}>
          <ToggleSwitch
            checked={acceptTerms}
            onChange={setAcceptTerms}
            id="acceptTerms"
          />
          <label htmlFor="acceptTerms" className={styles.acceptForm_label}>
            <span>
              Совершая оплату, я подтверждаю, что ознакомлен и согласен, с тем, что оплата за
              аренду кортов и инвентаря не возвращается, забронированное время не переносится.
            </span>
          </label>
        </div>
      </div>
      <div className={styles.acceptForm_section}>
        <div className={styles.toggleSection}>
          <ToggleSwitch
            checked={acceptOffer}
            onChange={setAcceptOffer}
            id="acceptOffer"
          />
          <label htmlFor="acceptOffer" className={styles.acceptForm_label}>
            <span>
              Совершая оплату, я подтверждаю что ознакомлен и согласен с{" "}
              <Link to="/rules">
                условиями оферты и правилами клуба
              </Link>
            </span>
          </label>
        </div>
      </div>
      {/* <div className={styles.acceptForm_section}>
        <div className={styles.toggleSection}>
          <ToggleSwitch
            checked={acceptGrunt}
            onChange={setAcceptGrunt}
            id="acceptGrunt"
          />
          <label htmlFor="acceptGrunt" className={styles.acceptForm_label}>
            <span>
              В случае закрытия грунтовых кортов по погодным условиям, Вы можете в мобильном приложении перейти на крытый корт с доплатой разницы в цене корта при условии наличия свободного корта на этот же или следующий час. Если свободных кортов нет - то время на грунте сгорает.
            </span>
          </label>
        </div>
      </div> */}
      <Button
        type="submit"
        newStyles={styles.button}
        disabled={!isAllAccepted}
      >
        <span>
          Оплатить{' '}
          <span>
            {totalPrice}
          </span>
        </span>
      </Button>
    </form>
  );
};
